import React from 'react';
import { Helmet } from 'react-helmet';
import favicon from '../../../static/favicon.png';

function SEO({ description, title }) {
  return (
    <Helmet
      htmlAttributes={{
        lang: 'en',
      }}
      title={title}
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: 'og:description',
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
      ]}
      link={[
        {
          rel: 'shortcut icon',
          type: 'image/png',
          href: `${favicon}`,
        },
      ]}
    />
  );
}

export default SEO;
